/* CLIENT ADDITIONAL TEAMS */

import { IDischargeDetails } from '~/store/client/types';
import { IClientDetailedV3 } from '../client/types';
import { privateAxios } from '../requestsCollection';
import { IResponse } from '../types';
import { IClientTeamRequest, IRequestParams } from './types';

export const createTeam = (
  { clinicId, teamId, clientId }: IRequestParams,
  data: IClientTeamRequest,
): IResponse<IClientDetailedV3> =>
  privateAxios(
    {
      method: 'post',
      url: `clinic/${clinicId}/act-team/${teamId}/client/${clientId}/client-team`,
      data,
    },
    'v3',
  );

export const updateTeam = (
  { clinicId, teamId, clientId, id }: IRequestParams,
  data: Omit<IClientTeamRequest, 'teamId'>,
): IResponse<IClientDetailedV3> =>
  privateAxios(
    {
      method: 'put',
      url: `clinic/${clinicId}/act-team/${teamId}/client/${clientId}/client-team/${id}`,
      data,
    },
    'v3',
  );

export const archiveTeam = ({
  clinicId,
  teamId,
  clientId,
  id,
  ...data
}: IRequestParams & IDischargeDetails): IResponse<IClientDetailedV3> =>
  privateAxios(
    {
      method: 'delete',
      url: `clinic/${clinicId}/act-team/${teamId}/client/${clientId}/client-team/${id}`,
      data,
    },
    'v3',
  );

export const restoreTeam = ({
  clinicId,
  teamId,
  clientId,
  id,
}: IRequestParams): IResponse<IClientDetailedV3> =>
  privateAxios(
    {
      method: 'post',
      url: `clinic/${clinicId}/act-team/${teamId}/client/${clientId}/client-team/${id}/recover`,
    },
    'v3',
  );
